import dayjs, { Dayjs } from "dayjs";

export const calculateDuration = (startDate: Dayjs, endDate: Dayjs): number => {
    const start = dayjs(startDate);
    const end = dayjs(endDate);
    return end.diff(start, "day");
}

export const getNRCTownshipCode = (township: string): string => {
    const regex = /\((.*?)\)/;
    const match = township?.match(regex);

    const result = match ? match[1] : "";
    return result?.trim();
}

export function convertEnglishToBurmeseNumerals(inputString: string): string {
    const englishToBurmeseMap: Record<string, string> = {
        '0': '၀',
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉'
    };

    // Use replace with a regular expression and a replacer function
    return inputString.replace(/[0-9]/g, (digit) => englishToBurmeseMap[digit]);
};

export function convertBurmeseToEnglishNumerals(inputString: string): string {
    const burmeseToEnglishMap: Record<string, string> = {
        '၀': '0',
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9'
    };

    // Use replace with a regular expression and a replacer function
    return inputString.replace(/[u1040-\u1049]/g, (digit) => burmeseToEnglishMap[digit]);
};


export function commonGreatestDivisor(a: number, b: number): number {
    if (b === 0) {
        return a;
    }
    return commonGreatestDivisor(b, a % b);
}

export function getAspectRatio(width: number, height: number): string {
    if (width === 0 || height === 0) {
        return "1:1"; // Default aspect ratio if either dimension is zero
    }

    const gcd = commonGreatestDivisor(width, height);
    return `${width / gcd}:${height / gcd}`;
}

export async function createFileFromUrl(url: string, filename: string, mimeType: string): Promise<File> {
    return fetch(url)
        .then(response => response.blob())
        .then(blob => {
            return new File([blob], filename, { type: mimeType });
        });
};